// DecodedTokenPanel.tsx

import React from "react";
import { Typography, Box, Paper } from "@mui/material";

interface DecodedTokenPanelProps {
  decodedToken: any;
  isShown: boolean;
  title: string;
  maxHeight?: string; // Added for constrained height
}

const DecodedTokenPanel: React.FC<DecodedTokenPanelProps> = ({
  decodedToken,
  isShown,
  title,
  maxHeight = "100%", // Default to 100% if not specified
}) => {
  return (
    <Box sx={{ mb: 2 }}>
      {title && (
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
      )}
      {isShown ? (
        decodedToken ? (
          <Paper
            elevation={0}
            variant="outlined"
            sx={{
              padding: 1.5,
              backgroundColor: "#f9f9f9",
              maxHeight: maxHeight,
              overflow: "auto",
              fontSize: "0.95rem",
              borderRadius: 1,
            }}
          >
            <pre
              style={{
                margin: 0,
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
              }}
            >
              {JSON.stringify(decodedToken, null, 2)}
            </pre>
          </Paper>
        ) : (
          <Typography variant="body2" color="text.secondary">
            No decoded token to display.
          </Typography>
        )
      ) : (
        <Typography variant="body2" color="text.secondary">
          Decoded token is hidden.
        </Typography>
      )}
    </Box>
  );
};

export default DecodedTokenPanel;